import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./helpDesafios.module.css";

import { useNavigate } from "react-router";

import Header, {
  NoHeaderScroll,
  HomeHeaderLeft,
} from "../../components/navigation/header";

function HeaderCenter() {
  return <div></div>;
}

export function HelpBackgroundFlair() {
  return (
    <div>
      <img
        className={styles.background}
        src={require("../../assets/images/games/hotChallengesPreGame/background.png")}
        alt=""
      />
      <div className={styles.gradient}></div>
    </div>
  );
}

export default function HelpDesafiosPicantes() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNext = () => {
    navigate("/hot-challenges");
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header HeaderLeft={HomeHeaderLeft} HeaderCenter={HeaderCenter} />
      <HelpBackgroundFlair />
      <NoHeaderScroll className="p-5 pt-2">
        <div className="flex flex-col h-full">
          <h2 className="text-4xl font-bold">{t("howToPlay")}</h2>
          <div className="flex items-end flex-1">
            <p className="font-medium text-xl text-center">
              {t("howToPlayHotChallenge")}
            </p>
          </div>

          <div className="flex-1 relative">
            <img
              className={`${styles.img1} zoom-in`}
              style={{ "--animation-delay": "300ms" }}
              src={require("../../assets/images/howToPlay/hotChallenge1.png")}
              alt="how-to-1"
            />
            <img
              className={`${styles.img2} zoom-in`}
              style={{ "--animation-delay": "600ms" }}
              src={require("../../assets/images/howToPlay/hotChallenge2.png")}
              alt="how-to-2"
            />
            <img
              className={`${styles.img3} zoom-in`}
              style={{ "--animation-delay": "900ms" }}
              src={require("../../assets/images/howToPlay/hotChallenge3.png")}
              alt="how-to-3"
            />
          </div>

          <div className="pt-5 pb-5">
            <button
              type="button"
              onClick={handleNext}
              className="btn btn-brand btn-small w-full pt-3 pb-3"
            >
              {t("next")}
            </button>
          </div>
        </div>
      </NoHeaderScroll>
    </div>
  );
}
